import loadConstants from 'utils/loads/constants';

import getNumberOfPalletsFormatted from 'utils/loads/formatters/getNumberOfPalletsFormatted';

export const groupPalletsByType = (rawLoads) => {
  const loads = rawLoads.map((l) => ({
    numberOfPallets: l[loadConstants.FIELDS.NUMBER_OF_ITEMS],
    palletType: l[loadConstants.FIELDS.PALLET_TYPE],
    loadType: l[loadConstants.FIELDS.LOAD_TYPE],
    length: l[loadConstants.FIELDS.ITEM_LENGTH],
    width: l[loadConstants.FIELDS.ITEM_WIDTH],
    height: l[loadConstants.FIELDS.ITEM_HEIGHT],
    weight: l[loadConstants.FIELDS.TOTAL_WEIGHT],
  }));

  const sortedLoads = loads.sort(function (a, b) {
    const loadTypeOrder = a.loadType.localeCompare(b.loadType);
    const palletTypeOrder = a.palletType.localeCompare(b.palletType);
    return loadTypeOrder || palletTypeOrder;
  });
  const palletsGroupedByType = sortedLoads.reduce((acc, load) => {
    const { palletType, numberOfPallets, length, width, loadType } = load;
    let key = palletType;
    if (
      palletType === loadConstants.PALLET_TYPES.CUSTOM_PALLET ||
      loadType !== loadConstants.LOAD_TYPES.PALLET
    ) {
      key = `${loadType}-${length}-${width}`;
    }
    const palletGroup = acc[key] ? acc[key] : { numberOfPallets: 0 };
    acc[key] = {
      ...load,
      numberOfPallets: palletGroup.numberOfPallets + numberOfPallets,
    };

    return acc;
  }, {});
  return palletsGroupedByType;
};

export const getGroupedNumberPalletsFormattedArray = ({ loads, t }) => {
  const palletsGroupedByType = groupPalletsByType(loads);

  const formattedLoads = Object.values(palletsGroupedByType).map((group) => ({
    sizes: getNumberOfPalletsFormatted({ ...group, t }),
    height: group.height,
    weight: group.weight,
  }));
  return formattedLoads;
};

const getGroupedNumberPalletsFormatted = ({ loads, t }) => {
  const palletsGroupedByType = groupPalletsByType(loads);

  const formattedLoads = Object.values(palletsGroupedByType).reduce(
    (acc, load) => [...acc, getNumberOfPalletsFormatted({ ...load, t })],
    []
  );

  if (formattedLoads.length === 1) {
    return formattedLoads;
  }

  return [
    formattedLoads.slice(0, -1).join(', '),
    formattedLoads.slice(-1),
  ].join(` ${t('and')} `);
};

export default getGroupedNumberPalletsFormatted;
